import { render } from "./DashboardChartsForm.vue?vue&type=template&id=0455d568"
import script from "./DashboardChartsForm.vue?vue&type=script&lang=js"
export * from "./DashboardChartsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__